module.exports = __webpack_public_path__ + "media/images/restaurant-9fd80b953859facf8f9a978ddd9fd8ce.svg";